/*#########################################################################################
#                                                                                         #
#    Freshwater v2.0 GLOBAL JS FILE                                                       #
#    ------------------------------                                                       #
#    Used for site-wide JS functionality.                                                 #
#                                                                                         #
#########################################################################################*/


/*#########################################################################################
#    Constants & Global Variables                                                         #
#########################################################################################*/

const   $freshDocument = $0(document),
        $freshWindow = $0(window),
        freshMaxWsm = 767;

var     onLoad = '',
        onResize = '',
        lazyLoadInstance = new LazyLoad({ });


/*#######################################################################################
#    Fresh Global Functions                                                             #
#########################################################################################*/

/******************************************************************************************
 * Title: Debounce Execution Control
 *
 * Description:
 * Debounce Function (https://davidwalsh.name/javascript-debounce-function)
 * Delays the execution of a function to limit its rate of operation, ideal for events like scrolling.
 * This helps in reducing the frequency of function calls to improve performance.
 *
 * Parameters:
 * @param {Function} func - Function to debounce.
 * @param {Number} wait - Milliseconds to delay before invoking the function.
 * @param {Boolean} immediate - If true, triggers the function on the leading edge instead of the trailing.
 *
 * @author Alexander Khost
 *******************************************************************************************/ 
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


/********************************************************************************************
 * Title: ADA Compliance Fix for Slick Carousels
 *
 * Description:
 * Fixes ADA compliance for Slick carousels without dots. 
 * Ensures that proper ARIA attributes are set for enhanced accessibility in carousels.
 * This function dynamically adjusts ARIA attributes to meet accessibility standards.
 *
 * Reference: 
 * https://www.beacontechnologies.com/blog/2017/11/how-to-remove-aria-described-by-if-dots-are-disabled-in-slick-slider.aspx
 *
 * Parameters:
 * @param {string|object} slickCarousel - The Slick carousel element (or selector) to be modified.
 * 
 * @author Alexander Khost
 ********************************************************************************************/
function freshCheckSlickAriaAttributes( slickCarousel ) {
    $0( slickCarousel ).find('li').each(function () {
        let $slide = $0(this);
        if ($slide.attr('aria-describedby') != undefined) {
            $slide.attr('id', $slide.attr('aria-describedby'));
        }
    });
}


/********************************************************************************************
 * Title: Open External Links in New Window
 *
 * Description:
 * Opens all external links within 'body' in a new window.
 * This function enhances the user experience by allowing users to stay on the current page 
 * while enabling them to view the content of external links in a new window.
 * 
 * Reference: https://css-tricks.com/snippets/jquery/open-external-links-in-new-window/
 * 
 * * @param {string} filter - an optional list of paths to targetted external links, defaults to filter out reviews links
 *
 * @author Alexander Khost
 ********************************************************************************************/
function freshOpenExternalLinksInNewWindow(filter) {
    if(!filter) {
        filter = 'a:not(.jdgm-paginate__page,.jdgm-star,.jdgm-paginate__load-more)';
    }
    $0('body').find(filter).each(function() {
          var a = new RegExp('/' + window.location.host + '/');
          if(!a.test(this.href)) {
              $0(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
              });
          }
    });
}


/********************************************************************************************
 * Title: Smooth Scrolling for Anchor Links
 *
 * Description:
 * Implements smooth scrolling for internal anchor links.
 * This function enhances the user experience by creating a seamless and visually pleasing 
 * navigation experience when users click on internal anchor links within the page.
 *
 * @author Alexander Khost
 ********************************************************************************************/
function smoothScrollToInlineAnchors() {
  $freshDocument.on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $0('html, body').animate({
        scrollTop: $0($0.attr(this, 'href')).offset().top
    }, 500);
  });
}

/********************************************************************************************
* Title: Animation Reinitialization on Page Reload
*
* Description:
* This function ensures that certain animations are properly triggered even after a user reloads the page.
* Adapted for the Dawn theme --Alex 20230808
*
* @author Alexander Khost 
/********************************************************************************************/
function initializeAnimationOnReload() {
  setTimeout(() => {
    if (typeof initializeScrollAnimationTrigger === "function") {
        initializeScrollAnimationTrigger();
    }
  }, 350);
}


/********************************************************************************************
 * Title: Accordion Behavior Handler
 *
 * Description:
 * This function toggles the visibility of accordion content and ensures only one item is open at a time.
 * - Toggles 'active' class on clicked accordion headers.
 * - Adjusts the maximum height of the accordion content to show/hide it.
 * - Swaps icons in the accordion header to indicate its state (open/close).
 * - Closes any other open accordion items to maintain only one active item.
 * Note: Customized for specific icons (icon1 and icon2) within the accordion headers.
 * 
 * @author Ahmed Ezzaouia
/********************************************************************************************/
function fresh_toggleAccordion() {
  $0('.accordion_item .accordion-header').click(function () {
      var button = $0(this);
      var accordionContent = button.next('.accordion-content');
      button.toggleClass('active');
      if (button.hasClass('active')) {
        accordionContent.css('maxHeight', accordionContent.prop('scrollHeight') + 'px');
        button.find('.icon1').hide();
        button.find('.icon2').show(); 
      } else {
        accordionContent.css('maxHeight', 0);
        button.find('.icon1').show();
        button.find('.icon2').hide(); 
      }
      // Close other open accordion items
      $0('.accordion_item .accordion-header')
        .not(button)
        .each(function () {
          $0(this).removeClass('active');
          $0(this).next('.accordion-content').css('maxHeight', 0);
          $0(this).find('.icon1').show();
          $0(this).find('.icon2').hide(); 
        });
  });
}


/*********************************************************************************************
 * Title: Hero Section Box Positioning
 *
 * Description:
 * Adjusts positioning of content boxes in hero sections.
 * - Finds each '.fresh-hero__box' within a '.fresh-hero' section.
 * - Calculates and sets the position of these boxes differently for small and large screens.
 *   - Uses 'heroboxxmd', 'heroboxymd' for large screens (width > 767px).
 *   - Uses 'heroboxxsm', 'heroboxysm' for small screens.
 * - Displays the box if it has text, hides it otherwise.
 * - Updated to support hero carousels with multiple hero slides --Alex, 20240411
 *
 * @author Ahmed Ezzaouia
 ********************************************************************************************/
function fresh_heroBoxPositioning(fresh_hero, fresh_box) {
    if($0(window).width() > 767){
        var leftPosition = ((fresh_hero.outerWidth() - fresh_box.outerWidth()) * fresh_hero.data('heroboxxmd')) / 100;
        var topPosition = ((fresh_hero.outerHeight() - fresh_box.outerHeight()) * fresh_hero.data('heroboxymd')) / 100;
      } else {
        var leftPosition = ((fresh_hero.outerWidth() - fresh_box.outerWidth()) * fresh_hero.data('heroboxxsm')) / 100;
        var topPosition = ((fresh_hero.outerHeight() - fresh_box.outerHeight()) * fresh_hero.data('heroboxysm')) / 100;
      }
     fresh_box.css('top', `${topPosition}px`);
     fresh_box.css('left', `${leftPosition}px`);
     fresh_box.css('display', 'block');
     if (!fresh_box.text().trim()) {
       fresh_box.css('display', 'none');
     }
}

var freshSetXY = () => {
   $0('.fresh-hero-container').each(function() {
     var fresh_carousel = $0(this).find('.fresh-slides');
    //if carousel, wait until slick has initialized, otherwise, just set the position
    if(fresh_carousel.length > 0) {
        fresh_carousel.on("init", function (event, slick) {
            //for each hero slide
            $0('.fresh_carousel__slide').each(function() {
                var fresh_hero = $0(this).find('.fresh-hero');
                var fresh_box = fresh_hero.find('.fresh-hero__box');
                fresh_heroBoxPositioning(fresh_hero, fresh_box);
            });
        });
     } else {
        var fresh_hero = $0(this).find('.fresh-hero');
        var fresh_box = fresh_hero.find('.fresh-hero__box');
        fresh_heroBoxPositioning(fresh_hero, fresh_box);
     }
   });
 };


/********************************************************************************************
 * Title: Slick Slider Initialization
 *
 * Description:
 * Initializes Slick sliders for all sections.
 * This function targets all elements with the specified slick slider class,
 * reads their data attributes for settings, and initializes the Slick slider
 * with those settings if they haven't already been initialized.
 *
 * @param {string} fresh_slick_class - The class selector for Slick elements.
 * 
 * @author Ahmed Ezzaouia
 ********************************************************************************************/ 
function fresh_slickInit(fresh_slick_class) {
  var fresh_slickElements = $0(fresh_slick_class);
  fresh_slickElements.each(function () {
    var fresh_slickElement = $0(this);
    if (fresh_slickElement.hasClass('fresh-is-animated')) return true;

    let slidesToShowMd = Number(fresh_slickElement.attr('data-slidesToShowMd'));
    let slidesToShowSm = Number(fresh_slickElement.attr('data-slidesToShowSm'));
    //as long as slides to show has not been turned off (0), set Slick
    if(
        (window.innerWidth >= 768 && slidesToShowMd != 0) ||
        (window.innerWidth < 768 && slidesToShowSm != 0)
    ) {
        var slickData = fresh_slickElement.attr('data-slick')
        if (!slickData) return false; 
        var fresh_slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
        if (!fresh_slickElement.hasClass('slick-initialized')) {
            // ADA: fix aria-hidden-focus — Slick leaves tabindex=0 on aria-hidden slides
            // ADA: fix broken aria-describedby — Slick adds aria-describedby pointing to
            //      dot button IDs that don't exist when dots are disabled
            fresh_slickElement.on('init afterChange', function() {
                $0(this).find('.slick-slide[aria-hidden="true"]')
                    .attr('tabindex', '-1')
                    .find('a, button, input, select, textarea, [tabindex]')
                    .attr('tabindex', '-1');
                $0(this).find('.slick-slide[aria-describedby]').each(function() {
                    var desc = $0(this).attr('aria-describedby');
                    if (desc && !document.getElementById(desc)) {
                        $0(this).removeAttr('aria-describedby');
                    }
                });
            });
            fresh_slickElement.slick(fresh_slickSettings);
            // ADA: fix list rule — remove list semantics from carousel <ul> so Slick's
            // injected <div>/<button> children don't violate the list structure rule
            if (fresh_slickElement.is('ul')) {
                fresh_slickElement.attr('role', 'presentation');
            }
        }
    }
  });

  //play and video audio
  videoSoundListener();

}


/********************************************************************************************
 * Title: Video Load for Responsive Design
 *
 * Description:
 * Ensures that mobile or desktop videos are loaded appropriately when 
 * the window is resized or a Shopify section is reloaded.
 * Targets '.fresh_video_desktop' for screens ≥ 768px and 
 * '.fresh_video_mobile' for screens < 768px.
 *
 * @author Ahmed Ezzaouia
 ********************************************************************************************/
const fresh_handleVideoLoad = () => {
  const fresh_videoDesktop = $0('.fresh_video_desktop');
  const fresh_videoMobile = $0('.fresh_video_mobile');
  if ($0(window).width() < 768) {
    fresh_videoMobile.each(function() {this.load()});
  } else {
    fresh_videoDesktop.each(function() {this.load()});
  }
};


/********************************************************************************************
 * Title: Infinite Scroll with Responsive Cloning
 *
 * Description:
 * Implements infinite scroll by dynamically cloning and appending elements within designated
 * containers. Enhances visual continuity for a seamless user experience. Responsive design 
 * ensures compatibility with various screen sizes.
 *
 * Usage:
 * To enable infinite scroll on an element, add the class (fresh_infinit-scoller) to the parent of the list.
 * 
 * Example usage in a Shopify section:
 * 
 * <div class="fresh_infinit-scoller" >
 *    <ul data-animation-speedMd=""
 *        data-animation-speedSm=""
 *    </ul>
 * </div>
 *
 * @Author Ahmed Ezzaouia
 ********************************************************************************************/
function fresh_infinite_scroll(e){
  console.log("🚀 ~ fresh_infinite_scroll fn: Event type: ", e.type)
  const scrollers = document.querySelectorAll(".fresh_infinit-scoller");
  scrollers.forEach(scroller=>{
    const list = scroller.querySelector('ul');

    //if the slides to scroll is set to 0 (for desktop and/or mobile), set the slide width to equal the size the image has been set to / remove white space around slide images
    let slidesToShowMd = Number(list.getAttribute('data-slidesToShowMd'));
    let slidesToShowSm = Number(list.getAttribute('data-slidesToShowSm'));
    let slidesMaxWidthMd = Number(list.getAttribute('data-slidesMaxWidthMd'));
    let slidesMaxWidthSm = Number(list.getAttribute('data-slidesMaxWidthSm'));
    if(window.innerWidth >= 768 && slidesToShowMd == 0) {
        for (var i = 0; i < list.children.length; i++) {
            let imageWidthMd = Number(list.children[i].getAttribute('data-imageWidthMd'));
            let slideWidth = slidesMaxWidthMd * imageWidthMd;
            if( list.children[i].querySelector('img') !== null ) {
                list.children[i].style.width = slideWidth + 'px';
                list.children[i].querySelector('img').style.maxWidth = '100%';
            }
        }
    } else if(window.innerWidth < 768 && slidesToShowSm == 0) {
        for (var i = 0; i < list.children.length; i++) {
            let imageWidthSm = Number(list.children[i].getAttribute('data-imagewidthMd')); //we're only supplying desktop slide images, and so, using md image on mobile for now --Alex 2024-03-20
            let slideWidth = slidesMaxWidthSm * imageWidthSm;
            if( list.children[i].querySelector('img') !== null ) {
                list.children[i].style.width = slideWidth + 'px';
                list.children[i].querySelector('img').style.maxWidth = '100%';
                list.children[i].querySelector('img').removeAttribute('loading'); //removing lazy load for mobile scrolling images due to a related Safari iOS bug --Alex 2024-06-11
            }
        }
    }
    
    //if using lazyload images, set the src to the data-src after cloning
    for (var i = 0; i < list.children.length; i++) {
        if(
            list.children[i].querySelector('img') !== null &&
            list.children[i].querySelector('img').getAttribute('src') == null &&
            list.children[i].querySelector('img').getAttribute('data-src') !== ''
            
        ) {
            list.children[i].querySelector('img').setAttribute('src', list.children[i].querySelector('img').getAttribute('data-src'));
        }
    }

    let animationSpeedMd = Number(list.getAttribute('data-animation-speedMd'))
    let animationSpeedSm = Number(list.getAttribute('data-animation-speedSm'))
    const duplicatedList = scroller.querySelector('.fresh-duplicated-list');
    if (duplicatedList) duplicatedList.remove();
    const clonedList = list.cloneNode(true);
    clonedList.classList.add('fresh-duplicated-list');
    list.classList.add('fresh-is-animated');
    clonedList.classList.remove('fresh-is-animated');
    scroller.appendChild(clonedList);
    var slickData = clonedList.getAttribute('data-slick');
    if (slickData) {
      var fresh_slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
      const desktopSlick = fresh_slickSettings.responsive[0].settings
      const mobileSlick = fresh_slickSettings.responsive[1].settings
      if (animationSpeedMd > 0 && desktopSlick !== 'unslick') animationSpeedMd = 0;
      if (animationSpeedSm > 0 && mobileSlick !== 'unslick') animationSpeedSm = 0;
    }
    if (window.innerWidth <= 768 && animationSpeedSm > 0) fresh_startAnimation(list, clonedList);
    else if (window.innerWidth > 768 && animationSpeedMd > 0) fresh_startAnimation(list, clonedList);
  });
}

function fresh_startAnimation(list, clonedList){
  clonedList.setAttribute('data-infinite-scroll', true);
  var totalWidth = 0;
  while (totalWidth < list.parentNode.offsetWidth * 11) {
    for (var i = 0; i < list.children.length; i++) {
      var clonedChild = list.children[i].cloneNode(true);
      clonedChild.setAttribute('aria-hidden', 'true');
      clonedList.appendChild(clonedChild);
      totalWidth += clonedChild.offsetWidth;
    }
  }
}


/********************************************************************************************
 * Title: Logo Click Handler
 *
 * Description:
 * Handles click events on logos, updating their opacity and displaying corresponding text.
 *
 * @Author Ahmed Ezzaouia
 ********************************************************************************************/
function handleLogoClick(e) {
  console.log("🚀 ~ handleLogoClick function: Event type: ", e.type)
  const logos = document.querySelectorAll('.fresh-logobar');
  const activeTexts = document.querySelectorAll('.fresh_bragbar_text');
  logos.forEach((logo) => {
    logo.addEventListener('click', () => {
      logos.forEach((logo) => {
        logo.style.opacity = '0.4';
      });
      logo.style.opacity = '1';
      activeTexts.forEach((activeText) => {
        activeText.style.display = 'none';
      });
      const blockId = logo.classList[1].replace('fresh-logobar--', '');
      const activeText = document.querySelector('.fresh_bragbar_text--' + blockId);
      activeText.style.display = 'block';
    });
  });
}


/********************************************************************************************
 * Title: Convert Video Poster Images to High Quality
 *
 * Description:
 * Strips the _small and _medium image path names from images to ensure a higher quality video
 *
 * @author Alexander Khost, based off https://community.shopify.com/c/shopify-design/why-are-my-video-thumbnails-blurry-on-the-dawn-theme/m-p/2291713
 ********************************************************************************************/
function freshConvertVideoPosterImages() {
    let videos = document.querySelectorAll('.fresh_video');
    videos.forEach(item=>{
        let newThumbnail = item.getAttribute('poster'); 
        if (newThumbnail.includes('_small')){ 
            newThumbnail = newThumbnail.replace('_small',''); 
            item.setAttribute('poster', newThumbnail)
        } else if (newThumbnail.includes('_medium')){ 
            newThumbnail = newThumbnail.replace('_medium',''); 
            item.setAttribute('poster', newThumbnail)
        }
    });
}


/********************************************************************************************
 * Title: On the Fly Add Functionality Buttons
 *
 * Description:
 *      - find all .fresh-button buttons and:
 *      - retireves the variant ID and optionally the selling plan ID, and adds the product to the cart.
 *      - retrieves the Klaviyo ID, triggers the Klaviyo sign up form
 *      - adds smooth scroll to an internal ID
 *
 * @author Alexander Khost
 ********************************************************************************************/
function freshAddFunctionalityButtons() {
    $0('.fresh-button').on('click', function (e) {
        var $this = $0(this),
            thisClasses = $this.attr('class').split(' '),
            qty = 1,
            variant_id,
            selling_plan,
            openForm,
            scrollId;
        
        $0.each(thisClasses, function(index, value){

            /* add to cart functionality */
            if(value != '' && value.split('-')[0] == 'freshvariant' && value.split('-')[1] != '' && value.split('-')[1] != undefined) {
                variant_id = value.split('-')[1].replace(/(?:\r\n|\r|\n)/g, '').replace(/[^\x00-\x7F]/g, "");
            }
            if(value != '' && value.split('-')[0] == 'freshquantity' && value.split('-')[1] != '' && value.split('-')[1] != undefined) {
                qty = value.split('-')[1].replace(/(?:\r\n|\r|\n)/g, '').replace(/[^\x00-\x7F]/g, "");
            }
            if(value != '' && value.split('-')[0] == 'freshsellingplan' && value.split('-')[1] != '' && value.split('-')[1] != undefined) {
                selling_plan = value.split('-')[1].replace(/(?:\r\n|\r|\n)/g, '').replace(/[^\x00-\x7F]/g, "");
            }

            /* Klaviyo functionality */
            if(value != '' && value.split('-')[0] == 'freshklaviyo' && value.split('-')[1] != '' && value.split('-')[1] != undefined) {
                e.preventDefault();
                e.stopPropagation();
                openForm = value.split('-')[1].replace(/(?:\r\n|\r|\n)/g, '').replace(/[^\x00-\x7F]/g, "");
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(['openForm', openForm]);
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            /* smooth scroll functionality */
            if(value != '' && value.split('-')[0] == 'freshscroll' && value.split('-')[1] != '' && value.split('-')[1] != undefined) {
                e.preventDefault();
                e.stopPropagation();
                scrollId = value.split('-')[1].replace(/(?:\r\n|\r|\n)/g, '').replace(/[^\x00-\x7F]/g, "");
                $0('html, body').animate({
                    scrollTop: $0('#' + scrollId).offset().top
                }, 500);
                return false;
            }

        });
        
        if (variant_id != '' && variant_id != undefined) {
            e.preventDefault();
            e.stopPropagation();
            freshAddProductToCart(variant_id,qty,selling_plan);
        }
    });
}

/********************************************************************************************
 * Title: Add Product to Cart
 *
 * Description:
 * Adds a product to the cart
 *
 * @author Alexander Khost
 ********************************************************************************************/
function freshAddProductToCart(variant_id,qty,selling_plan) {
    data = {
        "id": variant_id,
        "quantity": qty,
        "selling_plan": selling_plan,
    }
    return $0.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            //window.location = "/checkout";
        }
    });
}


function videoSoundListener() {
    $0(".video-sound-button span").click( function (){
        var $this = $0(this),
            $thisVideo = $this.parent().prev('video');
        //if muted, unmute this video
        if ( $thisVideo.prop('muted') == true ) {
            //first, mute all videos on the page to make sure this is the only one that will be playing
            $0('video').prop('muted', true);
            $0('.video-sound-button').find('img').attr('src', '//bhbcoffee.com/cdn/shop/t/64/assets/icon-sound-off.webp?v=123456496096089800281784228470');
            //unmute this video
            $thisVideo.prop('muted', false);
            $this.find('img').attr('src', '//bhbcoffee.com/cdn/shop/t/64/assets/icon-sound.webp?v=170174034767720897841784228470');
        }
        //else mute this video
        else {
            $thisVideo.prop('muted', true);
            $this.find('img').attr('src', '//bhbcoffee.com/cdn/shop/t/64/assets/icon-sound-off.webp?v=123456496096089800281784228470');
        }
    });
}


/*#########################################################################################
#                                                                                         #
#    Event Listeners                                                                      #
#    -----------------                                                                    #
#    Hook functions to specific events here.                                              #
#                                                                                         #
#########################################################################################*/

$0(document).ready(function() {
  freshOpenExternalLinksInNewWindow();
  smoothScrollToInlineAnchors();
  initializeAnimationOnReload();
  fresh_toggleAccordion();
  freshSetXY();
  freshConvertVideoPosterImages();
  freshAddFunctionalityButtons();
});

$0(document).ready(function(e) {
  fresh_infinite_scroll(e);
  fresh_slickInit(".fresh-slides");
//  freshSetXY();
  handleLogoClick(e);
});

// ADA: remove broken ARIA refs (aria-controls, aria-describedby).
// Note: aria-labelledby is intentionally excluded — removing it drops the accessible
// name, which creates a worse error than a broken ref. Those must be fixed at the source.
// Runs on window load + 800ms delay so all deferred scripts (Dawn's global.js,
// Slick, third-party apps) have finished adding their ARIA attributes first.
function freshCleanBrokenAriaRefs() {
  // ADA: remove aria-controls from details>summary — Dawn's global.js adds these but
  // <details> already handles disclosure natively; the refs are redundant and cause
  // WAVE "Broken ARIA reference" errors when the referenced element is hidden.
  document.querySelectorAll('details > summary[aria-controls]').forEach(function(el) {
    el.removeAttribute('aria-controls');
  });
  // Remove any remaining broken aria-controls or aria-describedby refs
  ['aria-controls', 'aria-describedby'].forEach(function(attr) {
    document.querySelectorAll('[' + attr + ']').forEach(function(el) {
      var targetId = el.getAttribute(attr);
      if (targetId && !document.getElementById(targetId)) {
        el.removeAttribute(attr);
      }
    });
  });
}
window.addEventListener('load', function() {
  setTimeout(freshCleanBrokenAriaRefs, 800);
});

$0(window).on('resize', debounce(function(e) {
  fresh_handleVideoLoad();
  freshSetXY();
  fresh_infinite_scroll(e);
  fresh_slickInit(".fresh-slides");
  handleLogoClick(e);
}, 100));

//sticky-header scrolling detection
var freshScroll = 0;
$freshWindow.scroll(function(){
    let $freshStickyHeader = $0('sticky-header').first(),
        freshStickyHeaderHeight = $freshStickyHeader.outerHeight();
    freshScroll = $freshWindow.scrollTop();

    if (freshScroll >= freshStickyHeaderHeight) {
        $freshStickyHeader.addClass('fresh-scrolled');
    } else {
        $freshStickyHeader.removeClass('fresh-scrolled');
    }
});
$0(document).ready(function() {
    let $freshStickyHeader = $0('sticky-header').first(),
        freshStickyHeaderHeight = $freshStickyHeader.outerHeight(),
        $mobileHeaderDrawer = $freshStickyHeader.find('header-drawer').first();
    $mobileHeaderDrawer.on('click',function() {
        if (freshScroll <= freshStickyHeaderHeight) {
            if($freshStickyHeader.hasClass('fresh-scrolled')) {
                $freshStickyHeader.removeClass('fresh-scrolled');
            } else {
                $freshStickyHeader.addClass('fresh-scrolled');
            }
        }
    });

    //video volume
    $0('<div class="video-sound-button"><span><img src="//bhbcoffee.com/cdn/shop/t/64/assets/icon-sound-off.webp?v=123456496096089800281784228470" alt="sound"></span></div>').insertAfter('video:first-of-type');
    videoSoundListener();

});

$0(document).on('shopify:section:load', function(e){
  lazyLoadInstance.update();
  fresh_toggleAccordion();
  fresh_handleVideoLoad();
  freshSetXY();
  fresh_infinite_scroll(e);
  fresh_slickInit(".fresh-slides");
  handleLogoClick(e);
  
});

$0(document).on('shopify:section:reorder', function(){
  lazyLoadInstance.update();
});

$0(document).on('shopify:block:load', function(e){
  fresh_infinite_scroll(e);
  fresh_slickInit(".fresh-slides");
  handleLogoClick(e);
});

//forgot password / cancel fix
document.addEventListener('DOMContentLoaded', function () {
    const recoverLink = document.querySelector('a[href="#recover"]');
    const loginLink = document.querySelector('a[href="#login"]');
    const recoverEl = document.querySelector('#recover');
    const loginEl = document.querySelector('#login');
    function clearActive() {
        recoverEl?.classList.remove('is-active');
        loginEl?.classList.remove('is-active');
    }
    if (recoverLink && recoverEl) {
        recoverLink.addEventListener('click', function (e) {
            e.preventDefault();
            clearActive();
            recoverEl.classList.add('is-active');
            history.replaceState(null, '', ' '); // removes hash
        });
    }
    if (loginLink && loginEl) {
        loginLink.addEventListener('click', function (e) {
            e.preventDefault();
            clearActive();
            loginEl.classList.add('is-active');
            history.replaceState(null, '', ' ');
        });
    }
    const hash = window.location.hash;
    if (hash === '#recover' && recoverEl) {
        recoverEl.classList.add('is-active');
        history.replaceState(null, '', ' ');
    } else if (hash === '#login' && loginEl) {
        loginEl.classList.add('is-active');
        history.replaceState(null, '', ' ');
    }
});


/* force autoplay on Slick within .slick-autoplay */
(function () {
  if (!($0 && $0.fn && $0.fn.jquery)) {
      return;
  }

  const SEL = '.slick-autoplay .fresh-slides';

  function enableAutoplay($s) {
      if (!$s.length || !$s.hasClass('slick-initialized')) return;

      try {
          $s.slick('slickPlay');
      } catch (e) {
          /* fallback to internal instance */
          const inst = $s.slick('getSlick');
          if (inst) {
              inst.options.autoplay = true;
              //inst.options.autoplaySpeed = 2000;
              inst.autoPlayClear && inst.autoPlayClear();
              inst.autoPlay && inst.autoPlay();
          }
      }
  }

  /* 1) Apply now if ready */
  $0(SEL + '.slick-initialized').each(function () { enableAutoplay($0(this)); });

  /* 2) Watch for (re)initialization / unslick → re-init cycles */
  const roots = $0('.slick-autoplay').toArray();
  roots.forEach(root => {
      const mo = new MutationObserver(() => {
          $0(SEL + '.slick-initialized', root).each(function () { enableAutoplay($0(this)); });
      });
      mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  });

  /* 3) Last-chance polling (handles lazy inits) */
  let tries = 0;
  (function poll() {
      const $found = $0(SEL + '.slick-initialized');
      if ($found.length) $found.each(function () { enableAutoplay($0(this)); });
      if (++tries < 100) requestAnimationFrame(poll); /* ~1.6s */
  })();
})();


/* 🔹 Freshwater — Cart Upsell Widget
   Handles "Add to Cart" from upsell carousel and initializes Slick
*/
(function() {
    let initTimeout = null;
    let isInitializing = false;
    
    // Truncate upsell product names to 25 characters
    function truncateUpsellNames() {
        const names = document.querySelectorAll('.cart-drawer__upsell-name');
        names.forEach(function(nameEl) {
            const text = nameEl.textContent.trim();
            if (text.length > 25) {
                nameEl.textContent = text.substring(0, 25) + '...';
            }
        });
    }
    
    function initUpsellCarousel(force = false) {
        const carousel = document.querySelector('.cart-drawer__upsell-carousel');
        if (!carousel) return;
        
        // Check if there are any slides to show first
        const slides = carousel.querySelectorAll('.cart-drawer__upsell-item');
        if (slides.length === 0) return;
        
        // If already initialized and working correctly, skip unless forced
        if (!force && typeof $0 !== 'undefined' && $0(carousel).hasClass('slick-initialized')) {
            const slickSlides = $0(carousel).find('.slick-slide:not(.slick-cloned)');
            const originalSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
            // If Slick has all slides, don't reinitialize
            if (slickSlides.length === originalSlides.length && originalSlides.length > 0) {
                return;
            }
        }
        
        // Prevent multiple simultaneous initializations
        if (isInitializing) return;
        isInitializing = true;
        
        // Destroy existing Slick instance if it exists
        if (typeof $0 !== 'undefined' && $0(carousel).hasClass('slick-initialized')) {
            carousel.classList.remove('slick-arrows-ready');
            $0(carousel).slick('unslick');
            // Small delay to ensure unslick completes
            setTimeout(function() {
                isInitializing = false;
                initUpsellCarousel(true);
            }, 100);
            return;
        }
        
        // Get settings from data-slick attribute
        const slickData = carousel.getAttribute('data-slick');
        if (!slickData) return;
        
        try {
            const slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
            
            // Initialize Slick directly with our settings
            if (typeof $0 !== 'undefined') {
                // Show all slides temporarily so Slick can detect them
                slides.forEach(function(slide) {
                    slide.style.display = '';
                });
                
                // Wait a frame to ensure slides are visible
                requestAnimationFrame(function() {
                    if (!carousel.parentNode) return;
                    
                    // Verify slides are still there
                    const currentSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
                    if (currentSlides.length === 0) return;
                    
                    // Initialize Slick - it should now detect all visible slides
                    $0(carousel).slick(slickSettings);
                    
                    // After initialization, verify all slides were detected
                    setTimeout(function() {
                        if ($0(carousel).hasClass('slick-initialized')) {
                            const slickSlides = $0(carousel).find('.slick-slide:not(.slick-cloned)');
                            const originalSlides = carousel.querySelectorAll('.cart-drawer__upsell-item');
                            
                            // If Slick didn't detect all slides, destroy and reinitialize
                            if (slickSlides.length !== originalSlides.length && originalSlides.length > 1) {
                                $0(carousel).slick('unslick');
                                // Show all slides again
                                originalSlides.forEach(function(slide) {
                                    slide.style.display = '';
                                });
                                // Wait a bit longer before reinitializing
                                setTimeout(function() {
                                    $0(carousel).slick(slickSettings);
                                    // Add class after reinitialization
                                    setTimeout(function() {
                                        if ($0(carousel).hasClass('slick-initialized')) {
                                            carousel.classList.add('slick-arrows-ready');
                                            truncateUpsellNames();
                                        }
                                    }, 100);
                                }, 200);
                            } else {
                                // All slides detected, add class to fade in arrows
                                carousel.classList.add('slick-arrows-ready');
                                // Truncate product names
                                truncateUpsellNames();
                            }
                        }
                    }, 400);
                });
            }
        } catch (err) {
            console.error('Failed to initialize upsell carousel', err);
        } finally {
            isInitializing = false;
        }
    }
    
    // Debounced version to prevent multiple rapid calls
    function debouncedInit(force = false) {
        if (initTimeout) {
            clearTimeout(initTimeout);
        }
        initTimeout = setTimeout(function() {
            initUpsellCarousel(force);
        }, 300);
    }
    
    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initUpsellCarousel, 100);
        });
    } else {
        setTimeout(initUpsellCarousel, 100);
    }
    
    // Re-initialize when cart drawer opens (watches for 'active' class)
    let lastActiveState = false;
    const cartDrawerObserver = new MutationObserver(function(mutations) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
            const isActive = cartDrawer.classList.contains('active');
            // When cart drawer opens, initialize
            if (isActive && !lastActiveState) {
                debouncedInit(true);
            }
            // When cart drawer closes, remove arrows-ready class to hide arrows
            if (!isActive && lastActiveState) {
                const carousel = document.querySelector('.cart-drawer__upsell-carousel');
                if (carousel) {
                    carousel.classList.remove('slick-arrows-ready');
                }
            }
            lastActiveState = isActive;
        }
    });
    
    // Watch for cart drawer class changes
    let cartDrawerObserving = false;
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        lastActiveState = cartDrawer.classList.contains('active');
        cartDrawerObserver.observe(cartDrawer, {
            attributes: true,
            attributeFilter: ['class']
        });
        cartDrawerObserving = true;
    }

    // Also watch for cart drawer being added to DOM
    const bodyObserver = new MutationObserver(function(mutations) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !cartDrawerObserving) {
            lastActiveState = cartDrawer.classList.contains('active');
            cartDrawerObserver.observe(cartDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
            cartDrawerObserving = true;
        }
    });
    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Re-initialize after cart updates
    document.addEventListener('cart:refresh', function() {
        debouncedInit(true);
    });
    
    // Truncate names after cart updates
    document.addEventListener('cart:refresh', function() {
        setTimeout(truncateUpsellNames, 600);
    });
    
    // Handle "Add to Cart" from upsell widget
    document.addEventListener('submit', async function(e) {
        const form = e.target.closest('.cart-drawer__upsell-form');
        if (!form) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const button = form.querySelector('button[type="submit"]');
        const originalText = button.textContent;
        
        button.disabled = true;
        button.textContent = 'Adding...';
        
        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            });
            
            if (!res.ok) throw new Error(`Failed to add item: ${res.status}`);
            
            // Refresh cart drawer
            if (typeof window.__fwBundle?.refreshCartSections === 'function') {
                await window.__fwBundle.refreshCartSections();
            } else if (typeof fwRefreshCartUI === 'function') {
                await fwRefreshCartUI(true);
            } else {
                location.reload();
            }
        } catch (err) {
            console.error('Failed to add upsell item to cart', err);
            button.disabled = false;
            button.textContent = originalText;
            alert('Sorry, we couldn\'t add that item to your cart. Please try again.');
        }
    });
})();
